<template>

  <div class="ag-grid-advance-select">
    <span v-if="!(canEdit && isEditing)" style="display: inline-block;width: 100%;height: 100%">
      {{ curLabel }}
    </span>
    <cargo-advance-select
      v-else
      ref="advanceSelect"
      :select-type="selectType"
      filterable
      :method-params="methodParams"
      :default-value="value||''"
      :tag-name="tagName"
      :tag-value="tagValue"
      :clearable="clearable"
      :allow-create="allowCreate"
      :style="attrs.style||'width:100%'"
      :class="attrs.classFunc? attrs.classFunc(params) : ''"
      :static-options="fullOptions"
      @parentCallBack="onChange"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
export default {
  name: 'AgGridAdvanceSelect',
  components: { cargoAdvanceSelect },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: () => null
    },
    canEdit: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => true
    },
    selectType: {
      type: String,
      default: () => ''
    },
    methodParams: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    }, attrs: {
      type: Object,
      default: () => ({})
    },
    tagName: {
      type: String,
      default: () => ''
    },
    tagValue: {
      type: String,
      default: () => ''
    },
    allowCreate: {
      type: Boolean,
      default: () => false
    },
    fullOptions: { type: Array, default: () => { return null } }
  },
  data() {
    return {
      selectObj: null,
      isEditing: false
    }
  },
  computed: {
    curLabel() {
      if (!this.value) {
        return ''
      }
      if (this.selectObj) {
        return this.selectObj[this.tagName]
      } else {
        let labelString = ''
        if (this.fullOptions) {
          const option = this.fullOptions.find(item => item[this.tagValue] === this.value)
          labelString = option ? option[this.tagName] : ''
        } else {
          labelString = ColumnUtils.resolveColumnLabel(this.selectType, this.tagValue, this.value, this.tagName) || ''
        }
        if (this.allowCreate) {
          return labelString || this.value
        }
        return labelString
      }
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal && !(this.canEdit && this.isEditing)) {
        this.selectObj = null
      }
    }
  },
  created() {
    window.addEventListener('click', this.clickOther)
  },
  destroyed() {
    window.removeEventListener('click', this.clickOther)
  },
  methods: {
    /* onClick() {
      if (this.canEdit) {
        this.isEditing = true
      }
    },*/
    onChange(p) {
      this.selectObj = p
      this.$emit('change', p)
    },
    clickOther(e) {
      if (this.isEditing === false && this.$el.contains(e.target)) {
        this.isEditing = true
      } else {
        this.isEditing = false
      }
    }
  }
}
</script>
